import { useLazyQuery, useQuery } from "@apollo/client";
import { PROSPECTION } from "../prospection.queries";
import {
  ProspectionQuery,
  ProspectionQueryVariables,
} from "../../../__generated__/ProspectionQuery";

export const useProspection = (id: number) => {
  return useQuery<ProspectionQuery, ProspectionQueryVariables>(PROSPECTION, {
    variables: { id },
  });
};

export const useLazyProspection = () => {
  return useLazyQuery<ProspectionQuery, ProspectionQueryVariables>(PROSPECTION);
};
